import { UserItemProps } from "apis";
import { lazy } from "react";

export const PageAdminUser = lazy(() => import("./List"));
export const PageAdminUserCreate = lazy(() => import("./Add"));
export const PageAdminUserUpdate = lazy(() => import("./Edit"));
export const PageAdminUserPermissionManager = lazy(() => import("./PermissionManager"));
export const PageAdminProfile = lazy(() => import("./Profile"));

export interface FormUserValuesProps extends UserItemProps {
    roleId?: number;
    positionId?: number;
    departmentId?: number;
    specialtyId?: number;
    password?: string;
    retypePassword?: string;
}

export interface FormSearchUserValuesProps {
    q?: string;
    roleIds?: string[];
    departmentIds?: string[];
    positionIds?: string[];
    specialtyIds?: string[]
}

export interface FormChangePasswordValuesProps {
    password: string;
    newPassword: string;
    retypePassword: string;
}